<nz-spin *ngIf="formGroup" nzSize="large" nzTip="Loading..." [nzSpinning]="isLoading">
  <nz-alert
    class="bottom-spacing"
    nzType="error"
    nzShowIcon
    nzCloseable
    nzMessage="Error"
    [nzDescription]="errorTpl"
    *ngIf="submitError || ehdError"
  ></nz-alert>

  <ng-template #errorTpl>
    <ng-container *ngIf="formGroup.invalid">
      <div *ngIf="formGroup.get('actualFinishDate')?.errors?.required">Please choose a date</div>
    </ng-container>

    <ng-container *ngIf="!formGroup.invalid && (submitError || ehdError)">
      <!-- EHD formatted error -->
      <ng-container *ngIf="ehdError">
        <strong class="mb-2" style="display: block">EHD validation errors found:</strong>

        <ul style="padding-left: 0; margin-top: 8px">
          <li
            *ngFor="let e of ehdErrors; trackBy: trackByEhdError"
            style="list-style: none; margin-bottom: 6px"
          >
            <nz-tag [nzColor]="e.severity === 'Failure' ? 'red' : 'orange'">
              {{ e.severity }}
            </nz-tag>

            {{ e.text }}
            <span class="text-muted">(Row {{ e.rowNumber }})</span>
          </li>
        </ul>
      </ng-container>

      <!-- SAP / backend error -->
      <em-error-result *ngIf="!ehdError" [subTitle]="submitError || ''"></em-error-result>
    </ng-container>
  </ng-template>

  <form nz-form [formGroup]="formGroup" (ngSubmit)="submitForm(formGroup)">
    <!-- actualFinishDate -->
    <nz-form-item>
      <nz-form-label nzRequired>Actual finish</nz-form-label>
      <nz-form-control nzHasFeedback [nzErrorTip]="actualFinishDateErrorTpl">
        <nz-date-picker formControlName="actualFinishDate" nzFormat="dd/MM/yyyy"></nz-date-picker>
      </nz-form-control>

      <ng-template #actualFinishDateErrorTpl let-control>
        <ng-container *ngIf="control.errors['required']">Please choose a date</ng-container>
      </ng-template>
    </nz-form-item>
    <!-- /actualFinishDate -->

    <!-- lockBom -->
    <nz-form-item *ngIf="isC47">
      <nz-form-control>
        <span nz-checkbox formControlName="isLockBom">
          <span>Lock BOM</span>
        </span>
      </nz-form-control>
    </nz-form-item>
    <!-- /lockBom -->

    <!-- actions -->
    <nz-form-item>
      <nz-form-control>
        <button type="submit" nz-button nzType="primary" [disabled]="!formGroup.valid">
          <i nz-icon nzType="save" nzTheme="fill"></i>
          Submit
        </button>
      </nz-form-control>
    </nz-form-item>
    <!-- /actions -->
  </form>
</nz-spin>
